import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M20 1H4a3 3 0 0 0-3 3v16a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3v-.195a163 163 0 0 1-4.24-2.136 161 161 0 0 0-4.324-2.177c-1.745 2.07-4.258 3.943-7.436 3.943-2.74 0-4.5-1.848-4.5-3.935 0-.998.338-2.009 1.095-2.771.761-.767 1.898-1.236 3.405-1.236 1.904 0 4.223.55 6.599 1.29.576-.965.965-1.928 1.102-2.783H6.5V9H11V7.5H5.5v-1H11V4h2v2.5h5.5v1H13V9h4.5v.5c0 .229-.056.514-.142.815a9 9 0 0 1-.386 1.069c-.27.64-.645 1.38-1.118 2.144 1.056.367 2.106.754 3.156 1.141 1.325.49 2.65.978 3.99 1.425V4a3 3 0 0 0-3-3M3.5 15.5c0 .702.962 2.347 3.5 2.347.866 0 1.877-.393 2.907-1.09.86-.584 1.701-1.36 2.437-2.227a32 32 0 0 0-2.813-1.096c-1.032-.337-1.891-.52-2.531-.52-1.354 0-3.5.958-3.5 2.586",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const brandPaymentsAlipay = { render };
export {
  brandPaymentsAlipay as default,
  render
};
//# sourceMappingURL=brand-payments-alipay.svg.js.map
